import { memoize, ValidationError } from '@amzn/vinyl-util'
import { ErrorOrigin } from '@amzn/vinyl-util'

export const Icons = {
    account: () => import('@/img/icon/account.svg'),
    add: () => import('@/img/icon/add.svg'),
    addInline: () => import('@/img/icon/addInline.svg'),
    addReaction: () => import('@/img/icon/addReaction.svg'),
    addToPlaylist: () => import('@/img/icon/addToPlaylist.svg'),
    addToQueue: () => import('@/img/icon/addToQueue.svg'),
    airplayAudio: () => import('@/img/icon/airplayAudio.svg'),
    airplayVideo: () => import('@/img/icon/airplayVideo.svg'),
    album: () => import('@/img/icon/album.svg'),
    alexa: () => import('@/img/icon/alexa.svg'),
    alexaCast: () => import('@/img/icon/alexaCast.svg'),
    alexaTiny: () => import('@/img/icon/alexaTiny.svg'),
    amazonMusic: () => import('@/img/icon/amazonMusic.svg'),
    arrowDown: () => import('@/img/icon/arrowDown.svg'),
    artist: () => import('@/img/icon/artist.svg'),
    attach: () => import('@/img/icon/attach.svg'),
    audibleCircle: () => import('@/img/icon/audibleCircle.svg'),
    audibleLight: () => import('@/img/icon/audibleLight.svg'),
    block: () => import('@/img/icon/block.svg'),
    boxCheck: () => import('@/img/icon/boxCheck.svg'),
    boxUncheck: () => import('@/img/icon/boxUncheck.svg'),
    calendar: () => import('@/img/icon/calendar.svg'),
    cancel: () => import('@/img/icon/cancel.svg'),
    cancelInline: () => import('@/img/icon/cancelInline.svg'),
    car: () => import('@/img/icon/car.svg'),
    caretDown: () => import('@/img/icon/caretDown.svg'),
    caretLeft: () => import('@/img/icon/caretLeft.svg'),
    caretRight: () => import('@/img/icon/caretRight.svg'),
    caretUp: () => import('@/img/icon/caretUp.svg'),
    carMode: () => import('@/img/icon/carMode.svg'),
    carModeOff: () => import('@/img/icon/carModeOff.svg'),
    castOff: () => import('@/img/icon/castOff.svg'),
    castOn: () => import('@/img/icon/castOn.svg'),
    closedCaptionsI18N: () => import('@/img/icon/closedCaptionsI18N.svg'),
    closedCaptionsUs: () => import('@/img/icon/closedCaptionsUs.svg'),
    computer: () => import('@/img/icon/computer.svg'),
    contract: () => import('@/img/icon/contract.svg'),
    copy: () => import('@/img/icon/copy.svg'),
    deleteFilled: () => import('@/img/icon/deleteFilled.svg'),
    deleteOutline: () => import('@/img/icon/deleteOutline.svg'),
    deleteOutlined: () => import('@/img/icon/deleteOutlined.svg'),
    djMode: () => import('@/img/icon/djMode.svg'),
    dolby: () => import('@/img/icon/dolby.svg'),
    done: () => import('@/img/icon/done.svg'),
    doneInline: () => import('@/img/icon/doneInline.svg'),
    doneInlineLight: () => import('@/img/icon/doneInlineLight.svg'),
    download: () => import('@/img/icon/download.svg'),
    downloadComplete: () => import('@/img/icon/downloadComplete.svg'),
    downloadFailed: () => import('@/img/icon/downloadFailed.svg'),
    downloadFilled: () => import('@/img/icon/downloadFilled.svg'),
    downloadOutline: () => import('@/img/icon/downloadOutline.svg'),
    downVote: () => import('@/img/icon/downVote.svg'),
    edit: () => import('@/img/icon/edit.svg'),
    enhance: () => import('@/img/icon/enhance.svg'),
    eq: () => import('@/img/icon/eq.svg'),
    equalizerOff: () => import('@/img/icon/equalizerOff.svg'),
    equalizerOn: () => import('@/img/icon/equalizerOn.svg'),
    exclamation: () => import('@/img/icon/exclamation.svg'),
    exclamationFilled: () => import('@/img/icon/exclamationFilled.svg'),
    expand: () => import('@/img/icon/expand.svg'),
    facebookcolor: () => import('@/img/icon/facebookcolor.svg'),
    facebookColorCircle: () => import('@/img/icon/facebookColorCircle.svg'),
    facebooklight: () => import('@/img/icon/facebooklight.svg'),
    fastForward: () => import('@/img/icon/fastForward.svg'),
    favoriteOff: () => import('@/img/icon/favoriteOff.svg'),
    favoriteOn: () => import('@/img/icon/favoriteOn.svg'),
    filter1: () => import('@/img/icon/filter1.svg'),
    filter1Cancel: () => import('@/img/icon/filter1Cancel.svg'),
    filter2: () => import('@/img/icon/filter2.svg'),
    fire: () => import('@/img/icon/fire.svg'),
    flag: () => import('@/img/icon/flag.svg'),
    follow: () => import('@/img/icon/follow.svg'),
    following: () => import('@/img/icon/following.svg'),
    followPending: () => import('@/img/icon/followPending.svg'),
    followPlaylist: () => import('@/img/icon/followPlaylist.svg'),
    fussball: () => import('@/img/icon/fussball.svg'),
    globe: () => import('@/img/icon/globe.svg'),
    goBack: () => import('@/img/icon/goBack.svg'),
    goForward: () => import('@/img/icon/goForward.svg'),
    grid: () => import('@/img/icon/grid.svg'),
    groupsFilled: () => import('@/img/icon/groupsFilled.svg'),
    groupsIndex: () => import('@/img/icon/groupsIndex.svg'),
    groupsOutline: () => import('@/img/icon/groupsOutline.svg'),
    handle: () => import('@/img/icon/handle.svg'),
    help: () => import('@/img/icon/help.svg'),
    homeFilled: () => import('@/img/icon/homeFilled.svg'),
    homeOutline: () => import('@/img/icon/homeOutline.svg'),
    IcActionRadiocheck: () => import('@/img/icon/IcActionRadiocheck.svg'),
    IcActionRadiouncheck: () => import('@/img/icon/IcActionRadiouncheck.svg'),
    IcActionSharefacebook: () => import('@/img/icon/IcActionSharefacebook.svg'),
    IcActionSharetwitter: () => import('@/img/icon/IcActionSharetwitter.svg'),
    IcOtherCamera: () => import('@/img/icon/IcOtherCamera.svg'),
    IcOtherCircle: () => import('@/img/icon/IcOtherCircle.svg'),
    IcOtherSpreadsheet: () => import('@/img/icon/IcOtherSpreadsheet.svg'),
    information: () => import('@/img/icon/information.svg'),
    instagramcirclelight: () => import('@/img/icon/instagramcirclelight.svg'),
    instagramcolor: () => import('@/img/icon/instagramcolor.svg'),
    instagramColorCircle: () => import('@/img/icon/instagramColorCircle.svg'),
    instagramlight: () => import('@/img/icon/instagramlight.svg'),
    iosmessage: () => import('@/img/icon/iosmessage.svg'),
    iosMessageCircle: () => import('@/img/icon/iosMessageCircle.svg'),
    jumpBack10: () => import('@/img/icon/jumpBack10.svg'),
    jumpBack15: () => import('@/img/icon/jumpBack15.svg'),
    jumpBack30: () => import('@/img/icon/jumpBack30.svg'),
    jumpForward10: () => import('@/img/icon/jumpForward10.svg'),
    jumpForward15: () => import('@/img/icon/jumpForward15.svg'),
    jumpForward30: () => import('@/img/icon/jumpForward30.svg'),
    library: () => import('@/img/icon/library.svg'),
    libraryFilled: () => import('@/img/icon/libraryFilled.svg'),
    lightning: () => import('@/img/icon/lightning.svg'),
    line: () => import('@/img/icon/line.svg'),
    lineCircle: () => import('@/img/icon/lineCircle.svg'),
    list: () => import('@/img/icon/list.svg'),
    live: () => import('@/img/icon/live.svg'),
    maestro: () => import('@/img/icon/maestro.svg'),
    maestrodoublestar: () => import('@/img/icon/maestrodoublestar.svg'),
    makePrivate: () => import('@/img/icon/makePrivate.svg'),
    makePublic: () => import('@/img/icon/makePublic.svg'),
    maximize: () => import('@/img/icon/maximize.svg'),
    menu: () => import('@/img/icon/menu.svg'),
    merch: () => import('@/img/icon/merch.svg'),
    message: () => import('@/img/icon/message.svg'),
    microphone: () => import('@/img/icon/microphone.svg'),
    minimum: () => import('@/img/icon/minimum.svg'),
    more: () => import('@/img/icon/more.svg'),
    mozartCreate: () => import('@/img/icon/mozartCreate.svg'),
    myMusic: () => import('@/img/icon/myMusic.svg'),
    next: () => import('@/img/icon/next.svg'),
    notifications: () => import('@/img/icon/notifications.svg'),
    notificationsOff: () => import('@/img/icon/notificationsOff.svg'),
    offline: () => import('@/img/icon/offline.svg'),
    overflow: () => import('@/img/icon/overflow.svg'),
    partyHorn: () => import('@/img/icon/partyHorn.svg'),
    pause: () => import('@/img/icon/pause.svg'),
    pdf: () => import('@/img/icon/pdf.svg'),
    phone: () => import('@/img/icon/phone.svg'),
    photoLibrary: () => import('@/img/icon/photoLibrary.svg'),
    pin: () => import('@/img/icon/pin.svg'),
    play: () => import('@/img/icon/play.svg'),
    playInline: () => import('@/img/icon/playInline.svg'),
    playlist: () => import('@/img/icon/playlist.svg'),
    playQueue: () => import('@/img/icon/playQueue.svg'),
    podcasts: () => import('@/img/icon/podcasts.svg'),
    preview30: () => import('@/img/icon/preview30.svg'),
    previous: () => import('@/img/icon/previous.svg'),
    primeCircle: () => import('@/img/icon/primeCircle.svg'),
    primeVideoCircle: () => import('@/img/icon/primeVideoCircle.svg'),
    profileFilled: () => import('@/img/icon/profileFilled.svg'),
    profileOutline: () => import('@/img/icon/profileOutline.svg'),
    queueEnd: () => import('@/img/icon/queueEnd.svg'),
    queueNext: () => import('@/img/icon/queueNext.svg'),
    recent: () => import('@/img/icon/recent.svg'),
    recentOutlined: () => import('@/img/icon/recentOutlined.svg'),
    refresh: () => import('@/img/icon/refresh.svg'),
    remove: () => import('@/img/icon/remove.svg'),
    removeInline: () => import('@/img/icon/removeInline.svg'),
    repeat: () => import('@/img/icon/repeat.svg'),
    repeatOne: () => import('@/img/icon/repeatOne.svg'),
    reply: () => import('@/img/icon/reply.svg'),
    rewind: () => import('@/img/icon/rewind.svg'),
    search: () => import('@/img/icon/search.svg'),
    searchFilled: () => import('@/img/icon/searchFilled.svg'),
    searchOutline: () => import('@/img/icon/searchOutline.svg'),
    sendMessage: () => import('@/img/icon/sendMessage.svg'),
    settings: () => import('@/img/icon/settings.svg'),
    shareAndroid: () => import('@/img/icon/shareAndroid.svg'),
    shareEmail: () => import('@/img/icon/shareEmail.svg'),
    shareEmbed: () => import('@/img/icon/shareEmbed.svg'),
    shareIos: () => import('@/img/icon/shareIos.svg'),
    shareLink: () => import('@/img/icon/shareLink.svg'),
    shuffle: () => import('@/img/icon/shuffle.svg'),
    sleepTimer: () => import('@/img/icon/sleepTimer.svg'),
    snapColor: () => import('@/img/icon/snapColor.svg'),
    song: () => import('@/img/icon/song.svg'),
    sort1: () => import('@/img/icon/sort1.svg'),
    sort2: () => import('@/img/icon/sort2.svg'),
    sort3: () => import('@/img/icon/sort3.svg'),
    sparkle: () => import('@/img/icon/sparkle.svg'),
    speaker: () => import('@/img/icon/speaker.svg'),
    speedNarration: () => import('@/img/icon/speedNarration.svg'),
    speedNarration0dot5x: () => import('@/img/icon/speedNarration0dot5x.svg'),
    speedNarration0dot8x: () => import('@/img/icon/speedNarration0dot8x.svg'),
    speedNarration1dot2x: () => import('@/img/icon/speedNarration1dot2x.svg'),
    speedNarration1dot4x: () => import('@/img/icon/speedNarration1dot4x.svg'),
    speedNarration1dot5x: () => import('@/img/icon/speedNarration1dot5x.svg'),
    speedNarration1dot6x: () => import('@/img/icon/speedNarration1dot6x.svg'),
    speedNarration1dot8x: () => import('@/img/icon/speedNarration1dot8x.svg'),
    speedNarration1x: () => import('@/img/icon/speedNarration1x.svg'),
    speedNarration2x: () => import('@/img/icon/speedNarration2x.svg'),
    speedNarration3x: () => import('@/img/icon/speedNarration3x.svg'),
    starHalfFilled: () => import('@/img/icon/starHalfFilled.svg'),
    startStation: () => import('@/img/icon/startStation.svg'),
    stop: () => import('@/img/icon/stop.svg'),
    tablet: () => import('@/img/icon/tablet.svg'),
    thumbDown: () => import('@/img/icon/thumbDown.svg'),
    thumbUp: () => import('@/img/icon/thumbUp.svg'),
    tiktokCircle: () => import('@/img/icon/tiktokCircle.svg'),
    trailer: () => import('@/img/icon/trailer.svg'),
    trophy: () => import('@/img/icon/trophy.svg'),
    twitchCircle: () => import('@/img/icon/twitchCircle.svg'),
    twitchCircleColor: () => import('@/img/icon/twitchCircleColor.svg'),
    twitter: () => import('@/img/icon/twitter.svg'),
    twitterCircle: () => import('@/img/icon/twitterCircle.svg'),
    twittercirclecolor: () => import('@/img/icon/twittercirclecolor.svg'),
    twittercirclelight: () => import('@/img/icon/twittercirclelight.svg'),
    twittercolor: () => import('@/img/icon/twittercolor.svg'),
    twitterColorCircle: () => import('@/img/icon/twitterColorCircle.svg'),
    twitterlight: () => import('@/img/icon/twitterlight.svg'),
    upgradeCircle: () => import('@/img/icon/upgradeCircle.svg'),
    upgradeFilled: () => import('@/img/icon/upgradeFilled.svg'),
    upgradeOutline: () => import('@/img/icon/upgradeOutline.svg'),
    upload: () => import('@/img/icon/upload.svg'),
    upVote: () => import('@/img/icon/upVote.svg'),
    video: () => import('@/img/icon/video.svg'),
    videoCamera: () => import('@/img/icon/videoCamera.svg'),
    videoOutlined: () => import('@/img/icon/videoOutlined.svg'),
    visibilityOff: () => import('@/img/icon/visibilityOff.svg'),
    visitExternal: () => import('@/img/icon/visitExternal.svg'),
    volumeDown: () => import('@/img/icon/volumeDown.svg'),
    volumeMute: () => import('@/img/icon/volumeMute.svg'),
    volumeOff: () => import('@/img/icon/volumeOff.svg'),
    volumeOn: () => import('@/img/icon/volumeOn.svg'),
    volumeUp: () => import('@/img/icon/volumeUp.svg'),
    warning: () => import('@/img/icon/warning.svg'),
    wave: () => import('@/img/icon/wave.svg'),
    whatsApp: () => import('@/img/icon/whatsApp.svg'),
    whatsAppCircle: () => import('@/img/icon/whatsAppCircle.svg'),
} as const

export type IconName = keyof typeof Icons

export const loadIcon: (icon: IconName) => Promise<string> = memoize(
    async (icon: IconName): Promise<string> => {
        if (!(icon in Icons))
            throw new ValidationError(`Icon not found: '${icon}'`, ErrorOrigin.INTERNAL)
        const mod = await Icons[icon]()
        return String(mod.default)
    },
    (key) => key
)
